import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import DEFAULT_ROUTES from "../../constants/routes";
import { getProjectInfo } from "../../utils/api/project_apis";
import { STATUS } from "../../utils/api/sharedfunction";
import GhostLoader from "../Loaders/ghostloader";
import { selectProject } from "../../features/projects/ProjectSlice";
import { resetAllState } from "../../features/replayslice";
import { reset as resetQueryState } from "../../features/query/querySlice";
import ResourceNotFound from "../NotFound/ResourceNotFound";
import NotFoundResourceIcon from "../NotFound/NotFoundResourceIcon";

const withProjectInfo = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        const { project_id } = useParams();
        const selectedProjectId = useSelector((state) => state?.projects?.selectedProject?.id);
        const dispatch = useDispatch();
        const [loading, setLoading] = useState(true);
        const [projectNotFound, setProjectNotFound] = useState(false);

        useEffect(() => {
            let cancelled = false;

            (async () => {
                setProjectNotFound(false);
                setLoading(true);

                if (!selectedProjectId && !project_id) {
                    navigate(`${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}`);
                    if (!cancelled) setLoading(false);
                    return;
                }

                if (project_id !== selectedProjectId && project_id) {
                    const result = await getProjectInfo();
                    if (cancelled) return;

                    if (result.status === STATUS.SUCCESS) {
                        setProjectNotFound(false);
                        dispatch(selectProject(result.data || {}));
                        dispatch(resetAllState());
                        dispatch(resetQueryState());
                    } else {
                        setProjectNotFound(true);
                    }
                }

                if (!cancelled) setLoading(false);
            })();

            return () => {
                cancelled = true;
            };
        }, [project_id, selectedProjectId, navigate, dispatch]);

        if (loading) {
            return <GhostLoader />;
        }

        if (projectNotFound) {
            return (
                <ResourceNotFound
                    icon={<NotFoundResourceIcon type="project" />}
                    title="Project not found"
                    message="This project may have been deleted or you don't have access."
                    actionLabel="Go to Projects"
                    onAction={() => navigate(`${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}`)}
                />
            );
        }

        return <WrappedComponent {...props} />;
    };
};

export default withProjectInfo;
